import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map, catchError, tap, throwError, of} from 'rxjs';

import { ApiService } from './api.service';
import { ApiPaths } from '../modules/utils/apipath.constants';

@Injectable({ providedIn: 'root' })
export class RegisterService {
  constructor(
    private apiService: ApiService,
    private http: HttpClient
  ) {}


  getTerms(): Observable<string> {
    //return this.http.get<string>('/api/terms'); // TODO alexis we dont know where the endpoint is
    //also there will be needed to change the 
        return this.http
          .get<{ content: string }>('../../assets/mock/terms.json')
          .pipe(map((res) => res.content));
  }

  getUserPrivacy(): Observable<string> {
    //return this.http.get<string>('/api/terms'); // TODO alexis we dont know where the endpoint is
    //also there will be needed to change the 
        return this.http
          .get<{ content: string }>('../../assets/mock/userprivacy.json')
          .pipe(map((res) => res.content));
  }

  private getAuthId(): string {
    // Try to get from localStorage first
    const storedAuthId = localStorage.getItem('externalAuthId');
    
    console.log('[RegisterService] Getting AuthId:', {
      storedAuthId: storedAuthId,
      isEmpty: !storedAuthId,
      allLocalStorage: Object.keys(localStorage)
    });
    
    // Return stored value or fall back to default
    return storedAuthId || '';
  }
  getProfessionalRols(): Observable<any[]> {
    const customHeaders = {
      'Api-Auth-Id': this.getAuthId(),
      'Api-Source-Info': 'eyJFdmVudFNvdXJjZVR5cGUiOiJGYWtlIEV2ZW50U291cmNlVHlwZSIsIkV2ZW50U291cmNlS2V5IjoiRmFrZSBFdmVudFNvdXJjZUtleSIsIkV2ZW50U291cmNlSXRlbSI6IkZha2UgRXZlbnRTb3VyY2VJdGVtIn0='
  }
    return this.apiService
      .get(ApiPaths.help.professionsList, undefined, { headers: customHeaders })
      .pipe(
        map((response) => {
          
          if (response) {
            return Object.entries(response).map(([key, value]) => ({
              value: key,
              label: value
            }));
          }
          return [];
      }),
      catchError(error => {
        
        throw error;
      })
    );
  }

  getCountrylist(): Observable<any[]> {
    const customHeaders = {
      'Api-Auth-Id': this.getAuthId(),
      'Api-Source-Info': 'eyJFdmVudFNvdXJjZVR5cGUiOiJGYWtlIEV2ZW50U291cmNlVHlwZSIsIkV2ZW50U291cmNlS2V5IjoiRmFrZSBFdmVudFNvdXJjZUtleSIsIkV2ZW50U291cmNlSXRlbSI6IkZha2UgRXZlbnRTb3VyY2VJdGVtIn0='
  }
    return this.apiService
      .get(ApiPaths.help.countriesList, undefined , { headers: customHeaders })
      .pipe(
        map((response: any[]) => {
          // Transform the new API response format to match our existing component expectations
          return response.map(item => {
            const countryData = item;
            const currentLang = 'es';
            
            return {
              // Use the ISO2 code as our value for proper country identification
              value: countryData.codeIso2,
              // Use localized country name based on current language
              label: currentLang === 'es' ? countryData.nameEs : countryData.nameEn,
              // Store the original data for any other needs
              dialCode: countryData.dialCode,
              originalValue: item.value,
              isoCode2: countryData.codeIso2,
              isoCode3: countryData.codeIso3,
              
            };
          });
        }),
        catchError(error => {
          return of([]);  // Return empty array on error
        })
    );
  }

  getphonePrefix(): Observable<any[]> {
    return this.http
      .get(`../../assets/mock/phoneprefix.json`)
      .pipe(
        map(response => {
          if (response) {
            return Object.entries(response).map(([countryCode, countryData]: [string, any]) => ({
              value: countryCode,
              label: `(${countryData.dialCode}) ${countryData.name}`,
              prefix: countryData.dialCode,
            }));
          }
          return [];
        }),
        catchError(error => {
          // If country-specific mock not found, fall back to general mock
          console.log("type error")
          throw error;
        })
      );
  }

  sendRegisterData(formData: any): Observable<any>{
    const customHeaders = this.getCustomHeaders();
    const userData = {
      // Map form fields to expected API format
      firstName: formData.firstName,
      lastName: formData.lastName,
      profession: formData.profession,
      email: formData.email,
      confirmEmail: formData.email,
      telephone: formData.telephone,
      postalCode: formData.postalCode,
      country: formData.country,
      password: formData.password,
      repeatPassword: formData.password,
      language: formData.language || 'es', // Default to Spanish if not provided
      
      // Consents
      consentSpecialDataProcessing: formData.ConsentSpecialDataProcessing || false,
      consentSpecialPartners: formData.ConsentSpecialPartners || false,
      termsAndConditionsFerrer: formData.termsConsent || false,
      termsAndConditionsHca: formData.dataConsent || false,
      
      // Additional fields with defaults
      isActive: true,
      isLocal: true,
      uci: formData.cedula || '',
      isVeeva: false,
      sfAccountID: '',
      workplace: '',
      externalId1: '',
      
      // Add any additional fields your API expects
      econsents: formData.econsents || [],
    };

  
    return this.apiService.post(ApiPaths.auth.register, 
            userData, 
            {headers: customHeaders}
        ).pipe(
          tap((response: any) => {
          }),
          catchError((error) => {
            // Log the error for debugging
            console.error('Authentication error:', error);
            return throwError(() => error);
          })
        );
  }

  sendVerificationEmail(formData: any): Observable<any>{
    const customHeaders = this.getCustomHeaders();
    
    return this.apiService.get(ApiPaths.auth.sendVerificationEmail(formData.email), 
            undefined, 
            {headers: customHeaders}
        ).pipe(
          tap((response: any) => {
          }),
          catchError((error) => {
            // Log the error for debugging
            return throwError(() => error);
          })
        );
  }

  checkUserVeevaInfo(email: string): Observable<any>{
    const customHeaders = this.getCustomHeaders();
    
    return this.apiService.get(ApiPaths.veeva.isEmailVeeva(email), 
            undefined, 
            {headers: customHeaders}
        ).pipe(
          tap((response: any) => {
          }),
          catchError((error) => {
            // Log the error for debugging
            return throwError(() => error);
          })
        );
  }

  private getCustomHeaders(): { [key: string]: string } {
    // Base required headers
    const authId = this.getAuthId();
    const headers: { [key: string]: string } = {
      'Content-Type': 'application/json',
      'Api-Auth-Id': authId,
      'accept': '*/*',
      'Api-Source-Info': 'eyJFdmVudFNvdXJjZVR5cGUiOiJGYWtlIEV2ZW50U291cmNlVHlwZSIsIkV2ZW50U291cmNlS2V5IjoiRmFrZSBFdmVudFNvdXJjZUtleSIsIkV2ZW50U291cmNlSXRlbSI6IkZha2UgRXZlbnRTb3VyY2VJdGVtIn0='
    };
    
    console.log('[RegisterService] Custom headers prepared:', {
      'Api-Auth-Id': authId,
      'Api-Auth-Id-Length': authId?.length || 0,
      'Is-Empty': !authId || authId === ''
    });

    // Add optional headers if they exist in localStorage
    const sessionId = localStorage.getItem('sessionId');
    if (sessionId) {
      headers['Api-Session-Id'] = sessionId;
    }

    const callback = localStorage.getItem('callback');
    if (callback) {
      headers['Api-Callback-Url'] = callback;
    }

    const product = localStorage.getItem('product');
    if (product) {
      headers['Api-Product-Flag'] = product;
    }

    return headers;
  }
}
